<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            Listas Newsletter

            <a
              @click="cadastrar_lista = true"
              data-toggle="modal"
              data-target="#cadastrar-modal"
              type="button"
              class="btn btn-info"
              style="margin-left: 15px"
            >
              <i class="fa-solid fa-plus" style="margin-right: 5px"></i>
              Nova lista
            </a>
          </h1>
        </div>
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/newsletter">Newsletter</a></li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <!-- CADASTRAR BLOCKNAME-->
  <div
    class="modal fade"
    id="cadastrar-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    @click.self="cadastrar_lista = false"
    @keydown.esc="cadastrar_lista = false"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" v-if="cadastrar_lista">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="color: black">&times;</button>
            <admin-cadastrar-newsletter-emails :closeModal="closeModal" :acaoRealizada="acaoRealizada" />
          </div>
        </div>
      </div>
    </form>
  </div>

  <div>
    <!-- TABELA DE registros -->
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Listas Newsletter</h3>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>
        </div>
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Id</th>
                <th>Nome</th>
                <th>Qtd. Emails</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lista, index) in newsletter_listas" :key="lista">
                <td>{{ index + 1 }}</td>
                <td>{{ lista.id }}</td>
                <td>{{ lista.nome }}</td>
                <td>{{ lista.emails_verificados_count }}</td>

                <td data-label="Ações">
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a @click="selecionarLista(lista)" class="dropdown-item" type="submit">
                      <i class="fas fa-pen"></i>
                      &nbsp;&nbsp; Editar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- EXIBIR DETALHES -->
        <div
          class="modal fade"
          @click.self="(exibir_detalhes = false), buscar()"
          @keydown.esc="(exibir_detalhes = false), buscar()"
          id="detalhes-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="imageModal"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body" >
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="(exibir_detalhes = false), buscar()">
                  &times;
                </button>
                <div v-if="exibir_detalhes">
                  <div class="card-body table-responsive p-0">
                    <admin-newsletter-emails-cadastrados
                      ref="emailsCadastrados"
                      :lista_selecionada="lista_selecionada"
                      :acaoRealizada="acaoRealizada"
                    />
                    <admin-newsletter-emails-nao-cadastrados :lista_selecionada="lista_selecionada" :acaoRealizada="acaoRealizada" />
                  </div>

                  <button
                    id="show_modal"
                    style="display: none; margin-left: 15px"
                    data-toggle="modal"
                    data-target="#detalhes-modal"
                    class="btn btn-danger btn-sm"
                  >
                    Fechar
                  </button>

                  <button
                    id="close_modal"
                    @click="(exibir_detalhes = false), buscar()"
                    style="margin-left: 15px"
                    data-toggle="modal"
                    data-target="#detalhes-modal"
                    class="btn btn-danger btn-sm"
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + newsletter_listas.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 150px"></div>
          </div>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

import ListarEmailsCadastrados from "./ListarEmailsCadastrados.vue";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController],

  components: [Loading, ListarEmailsCadastrados],

  data() {
    return {
      isLoading: false,
      registro_selecionado: "",
      filtro: "",
      paginas: [],
      registros: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      nome_contato: "",
      max_page: 0,
      editar_registro: false,
      cadastrar_registro: false,
      newsletter_listas: [],
      lista_selecionada: "",
      exibir_detalhes: false,
      cadastrar_lista: false,
    };
  },

  mounted() {
    console.log(this.registros);

    this.buscar();
  },

  methods: {
    acaoRealizada(acao) {
      if (acao == "editar") {
        this.cadastrar_lista = false;
        this.buscar();
      }

      if (acao == "cadastrar") {
        this.cadastrar_lista = false;
        this.buscar();
      }

      if (acao == "adicionar") {
        console.log("CHAMANDO ADICIONAR");
        this.$refs.emailsCadastrados.buscarEmailsByLista();
      }
    },

    closeModal() {
      this.editar_blockname = false;
      this.cadastrar_blockname = false;
    },

    selecionarLista(lista) {
      this.lista_selecionada = lista;
      this.exibir_detalhes = true;

      this.$nextTick(function () {
        let btn = document.getElementById("show_modal");
        btn.click();
      });
    },

    buscar() {
      this.isLoading = true;

      let data = {
        nome: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("URL =");
      console.log(data);

      axios
        .post("/admin/newsletter_listas/search", data)
        .then((response) => {
          this.newsletter_listas = response.data.newsletter_listas;
          this.total = response.data.total;

          console.log("RESPOSTA");
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    limparFiltros() {
      this.objeto = null;
      this.registros = [];
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);
      console.log("Max = " + this.max_page);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarRegistros();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1500px;
  margin-left: -430px;
}

@media screen and (max-width: 1600px) {
  .modal-content {
    width: 1350px;
    margin-left: -400px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1350px) {
  .modal-content {
    width: 1250px;
    margin-left: -350px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 1100px;
    margin-left: -280px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 1000px;
    margin-left: -240px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
    min-width: 400px;
  }
}
</style>
